import { render } from "./BusinessFooter.vue?vue&type=template&id=7b6cd86d&scoped=true"
const script = {}

import "./BusinessFooter.vue?vue&type=style&index=0&id=7b6cd86d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6cd86d"]])

export default __exports__